import { PncReport } from "./pnc-report";


export interface pncList{
    items: PncReport[],
    totalItems: number
}

export interface pncResponse{
    result: pncList
    success: boolean
}

export interface removeResponse{
    success: boolean
}

export class pncQueryParam{
  query: string;
  order: string;
  field: string;
  page: number;

  constructor(){
    this.query = '';
    this.order = '';
    this.field = '';
    this.page = 1;
  }
}
